export const SIMULATION_PROCESSING_EVENT = "connectz:simulation-processing";

export const SIMULATION_PROCESSING_STEPS = [
  "Opening the Simulations workspace",
  "Loading the production run and production line",
  "Validating stations, APP recipe, and inventory",
  "Preparing simulation controls",
] as const;

type SimulationProcessingEventDetail =
  | { action: "start" }
  | { action: "step"; step: number }
  | { action: "finish" };

function dispatchSimulationProcessing(detail: SimulationProcessingEventDetail): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(SIMULATION_PROCESSING_EVENT, { detail }));
}

export function startSimulationProcessing(): void {
  dispatchSimulationProcessing({ action: "start" });
}

export function updateSimulationProcessing(step: number): void {
  dispatchSimulationProcessing({
    action: "step",
    step: Math.max(0, Math.min(Math.trunc(step), SIMULATION_PROCESSING_STEPS.length - 1)),
  });
}

export function finishSimulationProcessing(): void {
  dispatchSimulationProcessing({ action: "finish" });
}

export function isSimulationHref(href: string): boolean {
  try {
    return new URL(href, "http://connectz.local").pathname.startsWith("/simulation");
  } catch {
    return false;
  }
}

export function simulationProcessingEventDetail(event: Event): SimulationProcessingEventDetail | null {
  if (!(event instanceof CustomEvent)) return null;
  const detail = event.detail as Partial<SimulationProcessingEventDetail> | null;
  if (!detail || (detail.action !== "start" && detail.action !== "step" && detail.action !== "finish")) {
    return null;
  }
  if (detail.action === "step") {
    return {
      action: "step",
      step: Math.max(
        0,
        Math.min(
          Math.trunc(Number(detail.step) || 0),
          SIMULATION_PROCESSING_STEPS.length - 1,
        ),
      ),
    };
  }
  return { action: detail.action };
}
